import * as ifNode from './if';
import * as loop from './loop';
import * as merge from './merge';
import * as switchNode from './switch';
import * as wait from './wait';
import * as executeWorkflow from './execute-workflow';

export const flow_controlNodes = {
  'if': ifNode,
  'loop': loop,
  'merge': merge,
  'switch': switchNode,
  'wait': wait,
  'execute-workflow-action': executeWorkflow,
};
